<script>
    import {onMount} from "svelte";
    import gsap from "gsap";
    import MorphSVGPlugin from 'gsap/MorphSVGPlugin';
    import {labels, mainTimeline} from "../../timelines/main-timeline";
    import isIOS from "../../helpers/isIOS";

    gsap.registerPlugin(MorphSVGPlugin);

    const telescopeTimeline = gsap.timeline();
    const telescopeOutTimeline = gsap.timeline();
    const lightRaysTimeline = gsap.timeline();
    const outTimeline = gsap.timeline();

    const {telescopeStart, telescopeEnd, lighthouseStart, lighthouseEnd } = labels;

    let scope;
    let stand;
    let telescopeWithStand;
    let lighthouse;
    let scopeTop;
    let lightHouseTop;

    let lighthouseBody;
    let scopeBody;
    let scopeParts;
    let lighthouseParts;
    let lightRays;
    let clipPath;
    let underline;
    let allPaths;

    const rotationPoint = {x: 63.45, y: 120.81};

    onMount(() => {

        mainTimeline
            .set(scope, {
                rotate: -180,
                scaleY: 0.6,
            }, 0)
            .fromTo(telescopeWithStand, {
                scale: 0,
                opacity: 0,
                duration: 1,
            }, {
                scale: 0.4,
                opacity: 1,
                y: 70,
            }, 'telescopeStart')
            .to(scope, {
                rotate: -110,
                duration: 1,
                scaleY: 1,
            }, 'telescopeStart')
            .to(scope, {
                rotate: -70,
                duration: 1,
            }, 'telescope0')
        ;

        telescopeOutTimeline
        .to(scope, {
            rotate: 0,
        })
        .to(MorphSVGPlugin.convertToPath(scopeBody), {
            morphSVG: {
                shape: MorphSVGPlugin.convertToPath(lighthouseBody),
                origin: '50% 50%',
            },
            duration: 1,
            x: -69,
            y: -10,
        })
        .to(MorphSVGPlugin.convertToPath(scopeTop), {
            morphSVG: {
                shape: MorphSVGPlugin.convertToPath(lightHouseTop),
                origin: '50% 50%',
            },
            duration: 1,
            x: -69,
            y: -10,
        }, '<')
        .to(scopeParts, {
            opacity: 0,
        }, '<')
        .to(stand, {
            opacity: 0,
        }, '<')
        .from(lighthouseParts, {
            opacity: 0,
            duration: 1.25,
        }, '<+=0.25')
        .from(underline, {
            opacity: 0,
            duration: 1.25,
        }, '<')
        .from(clipPath, {
            scale: 2,
            duration: 0.2,
        });

        lightRaysTimeline
            .from(lightRays, {
                opacity: 0,
            }, 0.3)
            .to(lightRays, {
                x: -74,
                scaleX: -0.4,
                duration: 1,
            })
            .to(lightRays, {
                y: 94,
                x: -83,
                scaleX: -0.3,
                transformOrigin: 'center',
                rotate: 240,
                duration: 1,
            });

        outTimeline
            .to(lightRays, {
                opacity: 0,
                duration: 1,
            })
            .to(allPaths, {
                y: 150,
                duration: 1,
            })
            .to(underline, {
                scaleX: 0,
                duration: 0.5,
                transformOrigin: 'center'
            }, '<+=0.5');

        mainTimeline.add(telescopeTimeline, telescopeStart);
        mainTimeline.add(telescopeOutTimeline, telescopeEnd);
        mainTimeline.add(lightRaysTimeline, lighthouseStart);
        mainTimeline.add(outTimeline, lighthouseEnd)
    });

</script>

<svg id="telescope" xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 130.07 340" overflow="visible">

    <clipPath id="clipPathSVG" bind:this={clipPath}>
        <rect class="cls-1" width="340" height="210" x="-100" y="86"></rect>
    </clipPath>

    <path bind:this={underline} class="cls-1 underline" d="M247.91,319.81H1c-.55,0-1-.45-1-1s.45-1,1-1H247.91c.55,0,1,.45,1,1s-.45,1-1,1Z"/>

    <g bind:this={allPaths}>
        <g class:isIOS={isIOS()}>
            <g bind:this={telescopeWithStand} class="scope-with-stand" >
                <g id="stand" bind:this={stand}>
                    <line class="cls-1" x1="38.04" y1="226.13" x2="1" y2="320.33"/>
                    <line class="cls-1" x1="92.02" y1="226.13" x2="129.07" y2="320.33"/>
                    <line class="cls-1" x1="64.5" y1="227.71" x2="64.5" y2="338.85"/>
                    <line class="cls-1" x1="24.81" y1="225.07" x2="105.25" y2="225.07"/>
                    <line class="cls-1" x1="57.89" y1="224.01" x2="57.89" y2="132.98"/>
                    <line class="cls-1" x1="67.94" y1="224.01" x2="67.94" y2="132.98"/>
                    <circle class="cls-1" cx="63.45" cy="120.81" r="12.44"/>
                </g>
                <g id="scope" bind:this={scope} class="scope-group">
                    <polygon class="cls-1" bind:this={scopeBody} points="39.14 113.54 34.65 231.11 94.31 230.71 85.87 41.05 41.34 40.43 39.74 101.59 39.14 113.54"/>
                    <polyline class="cls-1" bind:this={scopeTop} points="71.91 40.51 72.44 16.92 78.61 2.28 45.66 1 55.03 16.49 55 40.28"/>
                    <g bind:this={scopeParts}>
                        <line class="cls-1" x1="80.02" y1="155.54" x2="81.7" y2="216.26"/>
                        <polyline class="cls-1" points="94.31 230.71 103.05 230.09 104.98 254.64 25.08 254.64 25.28 230.93 34.65 231.11"/>
                        <line class="cls-1" x1="72.44" y1="16.92" x2="55.03" y2="16.49"/>
                        <circle class="cls-1" cx="63.45" cy="120.81" r="5.31"/>
                    </g>
                </g>
            </g>
        </g>
        <g bind:this={lighthouse} class="lighthouse" >
            <polygon bind:this={lighthouseBody} class="cls-2 hide" points="55.79 318.81 64.1 247.72 67.62 217.53 75.96 146.11 79.4 116.68 90.41 33.69 175.21 33.69 188.71 116.68 192.35 146.11 199.4 217.53 202.38 247.72 209.4 318.81 55.79 318.81"/>
            <path bind:this={lightHouseTop} class="cls-2 hide" d="M132.54,1c9.86,.01,19.29,3.99,26.18,11.04,5.81,5.82,9.55,13.49,10.62,21.65H95.1C97.58,15.59,113.71,1,132.54,1h0Z"/>
            <g bind:this={lighthouseParts}>
                <path class="cls-2" d="M149.62,319.15v-12.25c0-6.1-3.26-11.74-8.54-14.79-5.28-3.05-11.79-3.05-17.08,0-5.28,3.05-8.54,8.69-8.54,14.79v12.25"/>
                <path class="cls-1" d="M193.7,56.85H71.49c-.55,0-1-.45-1-1s.45-1,1-1h122.21c.55,0,1,.45,1,1s-.45,1-1,1Z"/>
                <path class="cls-1" d="M206.48,183.7H58.71c-.55,0-1-.45-1-1s.45-1,1-1H206.48c.55,0,1,.45,1,1s-.45,1-1,1Z"/>
                <path class="cls-1" d="M182.44,81.56H84.34c-.55,0-1-.45-1-1s.45-1,1-1h98.1c.55,0,1,.45,1,1s-.45,1-1,1Z"/>
                <path class="cls-1" d="M115.02,17.17c-.21,0-.41-.06-.59-.19-.44-.33-.54-.95-.21-1.4,3.81-5.18,9.91-8.27,16.34-8.27,.55,0,1,.45,1,1s-.45,1-1,1c-5.79,0-11.29,2.79-14.72,7.46-.2,.27-.5,.41-.81,.41Z"/>
                <polyline class="cls-2" points="188.64 116.68 137.92 116.68 79.33 116.68"/>
                <polyline class="cls-2" points="192.59 146.11 160.22 146.11 76.2 146.11"/>
                <polyline class="cls-2" points="67.5 217.53 165.53 217.53 199.28 217.53"/>
                <polyline class="cls-2" points="64.25 247.72 108.81 247.72 202.53 247.72"/>
            </g>
        </g>

        <g class="light" bind:this={lightRays}>
            <line class="cls-1" x1="324.39" y1="1" x2="1" y2="310.05"/>
            <line class="cls-1" x1="193.01" y1="157.04" x2="117.81" y2="228.9"/>
            <line class="cls-1" x1="98.67" y1="287.13" x2="71.67" y2="313.7"/>
            <line class="cls-1" x1="171.56" y1="215.41" x2="118.76" y2="267.36"/>
            <line class="cls-1" x1="207.4" y1="180.14" x2="186.04" y2="201.17"/>
            <line class="cls-1" x1="255.15" y1="133.16" x2="219.34" y2="168.4"/>
            <line class="cls-1" x1="224.01" y1="126.95" x2="207.46" y2="142.76"/>
            <line class="cls-1" x1="279.06" y1="74.8" x2="236.94" y2="116.19"/>
            <line class="cls-1" x1="203.66" y1="230.02" x2="182.29" y2="251.05"/>
        </g>
    </g>

</svg>

<style>

    #telescope {
        clip-path: url(#clipPathSVG);
    }

    .cls-1,
    line,
    polygon,
    circle {
        fill:none;
        stroke:#fff;
        stroke-linecap:round;
        stroke-linejoin:round;
        stroke-width:2px;
    }

    .cls-2 {
        fill:none;
        stroke:#fff;
        stroke-linecap:round;
        stroke-linejoin:round;
        stroke-width:2px;
    }


    .light {
        transform: scaleX(-0.2) scaleY(0.4) translate(-700px, 429px);
    }

    .lighthouse,
    .underline {
        transform: scale(0.4) translate(30px, 420px);
    }

    .hide {
        visibility: hidden;
    }

    .scope-with-stand {
        transform-origin: center center;
    }

    .scope-group {
        transform-origin: 38px 120px;
    }

    .isIOS {
        transform: translate(40px, 100px);
    }

</style>